export default __webpack_public_path__ + "static/media/no_candidate.bbb7086b.svg";